// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"5853":"0da58884b452cd36","7552":"e9a83bb8cc827ce4","9851":"2dfc3a9a946b0836"}[chunkId] + ".css";
};